<template>
    <div class="mapview">
        <div id="allmap"></div>
    </div>
</template>

<script>
export default {
    name: 'MapView',
    data() {
        return {
            currentPos: '',
            currentp: this.positionValue
        }
    },
    props: ['positionValue', 'lat', 'lng'],
    mounted() {
        this.initMap()
    },
    methods: {
        initMap() {
            this.createMap() // 创建地图
            this.setMapEvent() // 设置地图事件
            this.addMapControl() // 向地图添加控件
            if (!this.lat || !this.lng) {
                this.getCurrentPoint() // 获取当前位置
            } else {
                this.currentPos = this.positionValue
                // console.log()
            }
            // this.showPosition() // 显示选择的位置
        },
        createMap() {
            // BMap.init('PPD8QsbyXg0pY2XYnh16VhfXIf75LsMM')
            // console.log(this.lng, this.lat)
            var map = new BMap.Map('allmap') //在百度地图容器中创建一个地图
            var point = new BMap.Point(this.lng ? this.lng : 116.404, this.lat ? this.lat : 39.915) //定义一个中心点坐标
            // var point = new BMap.Point(116.404, 39.915) //定义一个中心点坐标
            // console.log(point)
            map.centerAndZoom(point, 11) //设定地图的中心点和坐标并将地图显示在地图容器中
            window.map = map //将map变量存储在全局
            this.$emit('getMap')
            this.showPositionBypoint(point)
        },
        setMapEvent() {
            map.enableDragging() //启用地图拖拽事件，默认启用(可不写)
            map.enableScrollWheelZoom() //启用地图滚轮放大缩小
            map.enableDoubleClickZoom() //启用鼠标双击放大，默认启用(可不写)
            map.enableKeyboard() //启用键盘上下左右键移动地图
        },
        getCurrentPoint() {
            // 获取当前位置
            let geolocation = new BMap.Geolocation()
            let myGeo = new BMap.Geocoder()
            let that = this
            geolocation.getCurrentPosition(function(r) {
                if(this.getStatus() == BMAP_STATUS_SUCCESS) {
                    let pt = r.point
                    that.showPositionBypoint(pt)
                    // myGeo.getLocation(pt, function(rs) {
                    //     let addComp = rs.addressComponents
                    //     that.currentPos = addComp.province + addComp.city + addComp.district + addComp.street + addComp.streetNumber
                    //     that.$emit('initprovincecity', addComp.province,addComp.city)
                    //     that.$emit('currentPos', that.currentPos,pt)
                    // })
                }       
            }, {enableHighAccuracy: true})
        },
        clearMarker() {
            map.clearOverlays()
        },
        getPrams(data) {
            // console.log(data)
            this.currentp = data
            this.showPosition()
        },
        showPosition() {
            // console.log('初始化=' + this.currentp)
            let that = this
            let myGeo = new BMap.Geocoder()
            myGeo.getPoint(this.currentp, function(point) {
                if (point) {
                    that.showPositionBypoint(point)
                    // console.log(222)
                    // that.clearMarker() // 清除上次定位marker
                    // let marker = new BMap.Marker(point)
                    // map.centerAndZoom(point, 12)
                    // map.addOverlay(marker)
                    // marker.enableDragging()
                    // console.log(point)
                    // that.$emit('currentPos', that.currentp,point)
                    // // marker.setAnimation(BMAP_ANIMATION_BOUNCE)
                    // marker.addEventListener('dragend', function(e){
                    //     let pt = e.point
                    //     let geoc = new BMap.Geocoder()
                    //     geoc.getLocation(pt, function(rs){
                    //         let addComp = rs.addressComponents
                    //         console.log(addComp)
                    //         let clickPoint = addComp.province + ',' + addComp.city + ',' + addComp.district + addComp.street + addComp.streetNumber
                    //         that.$emit('clickPoint', clickPoint,pt)
                    //     })      
                    // })
                } else {
                    console.log('您选择地址没有解析到结果!')
                }
            })
        },
        showPositionBypoint(point) {
            let that = this
            this.clearMarker() // 清除上次定位marker
            let marker = new BMap.Marker(point)
            map.centerAndZoom(point, 12)
            map.addOverlay(marker)
            marker.enableDragging()
            // this.$emit('currentPos', this.currentp,point)
            let myGeo = new BMap.Geocoder()
            myGeo.getLocation(point, function(rs) {
                let addComp = rs.addressComponents
                that.currentPos = addComp.province + addComp.city + addComp.district + addComp.street + addComp.streetNumber
                that.$emit('initprovincecity', addComp.province,addComp.city)
                that.$emit('currentPos', that.currentPos,point)
            })
            // marker.setAnimation(BMAP_ANIMATION_BOUNCE)
            marker.addEventListener('dragend', function(e){
                let pt = e.point
                let geoc = new BMap.Geocoder()
                geoc.getLocation(pt, function(rs){
                    let addComp = rs.addressComponents
                    console.log(addComp, rs)
                    let clickPoint = addComp.province + ',' + addComp.city + ',' + addComp.district + addComp.street + addComp.streetNumber
                    that.$emit('clickPoint', clickPoint, pt)
                })
            })
        },
        addMapControl() {
            //向地图中添加缩放控件
            var ctrl_nav = new BMap.NavigationControl({
                anchor: BMAP_ANCHOR_TOP_LEFT,
                type: BMAP_NAVIGATION_CONTROL_LARGE
            });
            map.addControl(ctrl_nav)

            //向地图中添加缩略图控件
            var ctrl_ove = new BMap.OverviewMapControl({
                anchor: BMAP_ANCHOR_BOTTOM_RIGHT,
                isOpen: true
            })
            map.addControl(ctrl_ove)

            //向地图中添加比例尺控件
            var ctrl_sca = new BMap.ScaleControl({
                anchor: BMAP_ANCHOR_BOTTOM_LEFT
            })
            map.addControl(ctrl_sca)
        }
    }
}
</script>

<style type="scss" lang="scss" type="text/scss">
    #allmap {
        width: 800px;
        height: 500px;
        margin: 20px auto;
    }
</style>
